/* eslint-disable no-new, no-unused-vars */

export default function initMap(elementDOM, lat, lon, zoom) {
	// Create a map object and specify the DOM element for display.
	const coordinate = { lat: +lat, lng: +lon };

	const map = new google.maps.Map(elementDOM, {
		center: coordinate,
		zoom: parseInt(zoom, 10),
	});

	const marker = new google.maps.Marker({
		position: coordinate,
		map,
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/googleMaps.js
 **/